module.exports = new __parcel__URL__("bruiserrogue.e9eeb464.png").toString();